export default __webpack_public_path__ + "static/media/message-promotion.7e726375.svg";